export function getDateParts(
  date: number | string,
): {
  frequency: string;
  year: string;
  month: string;
  day: string;
} {
  const stringifiedDate = String(date);

  return {
    frequency: stringifiedDate[0],
    year: stringifiedDate.slice(1, 5),
    month: stringifiedDate.slice(5, 7),
    day: stringifiedDate.slice(7, 9),
  };
}

export function getDateId(date: Date, frequency: number): number {
  const monthIndex = date.getMonth() + 1;
  const month = monthIndex > 9 ? monthIndex.toString() : "0" + monthIndex.toString();
  const day = date.getDate() > 9 ? date.getDate().toString() : "0" + date.getDate().toString();
  return Number(`${frequency}${date.getFullYear()}${month}${day}`);
}

export function getDateWithoutFrequency(date: number | string): number {
  return +String(date).slice(1);
}
